function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27 0C12.1074 0 0 12.1074 0 27C0 41.8926 12.1074 54 27 54C41.8926 54 54 41.8926 54 27C54 12.1074 41.8926 0 27 0ZM38.9937 22.6232L26.5453 36.0379C25.92 36.72 25.0105 37.1179 24.0442 37.1179C23.0779 37.1179 22.2253 36.72 21.5432 36.0379L15.0063 28.9326C13.7558 27.5684 13.8126 25.4084 15.1768 24.1011C16.5411 22.8505 18.7011 22.9074 20.0084 24.2716L24.1011 28.6484L34.0484 17.9053C35.3558 16.5411 37.459 16.4842 38.88 17.7347C40.1874 19.0989 40.3011 21.2589 38.9937 22.6232Z",
  fill: "#2E8917"
});

var SvgGreentick = function SvgGreentick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGreentick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/greentick.b09de86b.svg";
export { ForwardRef as ReactComponent };